var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.402344,
    width: 34,
    height: 25.2239,
    rx: 3,
    fill: "#001984",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0178 11.1772C27.9941 12.1243 27.9941 13.66 27.0178 14.6072C26.0415 15.5543 24.4585 15.5543 23.4822 14.6072C22.5059 13.66 22.5059 12.1243 23.4822 11.1772C24.4585 10.23 26.0415 10.23 27.0178 11.1772Z",
    fill: "#061A40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6428 11.1772C19.6191 12.1243 19.6191 13.66 18.6428 14.6072C17.6665 15.5543 16.0835 15.5543 15.1072 14.6072C14.1309 13.66 14.1309 12.1243 15.1072 11.1772C16.0835 10.23 17.6665 10.23 18.6428 11.1772Z",
    fill: "#061A40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2678 11.1772C11.2441 12.1243 11.2441 13.66 10.2678 14.6072C9.29146 15.5543 7.70854 15.5543 6.73223 14.6072C5.75592 13.66 5.75592 12.1243 6.73223 11.1772C7.70854 10.23 9.29146 10.23 10.2678 11.1772Z",
    fill: "#061A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActionIcon);
export default __webpack_public_path__ + "static/media/table-action-icon.c1b27deec029e88b04469318c900462b.svg";
export { ForwardRef as ReactComponent };